import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
export function ProblemSection() {
  const losses = ['paciencia', 'sueño', 'salud', 'humor', 'ganas', 'respeto por ti'];
  return <Section variant="dark" data-id="element-83">
      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} className="space-y-10" data-id="element-84">
        <div data-id="element-85">
          <h2 className="text-3xl font-bold text-white uppercase tracking-tight mb-6" data-id="element-86">
            El problema real{' '}
            <span className="text-neutral-500 text-xl block mt-1 normal-case font-normal" data-id="element-87">
              (nadie te lo dice así)
            </span>
          </h2>

          <p className="text-lg text-neutral-300 mb-6" data-id="element-88">
            Cuando odias tu trabajo, no solo pierdes horas.
          </p>

          <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-89">
            {losses.map((item, i) => <motion.div key={item} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-center text-red-400 font-medium" data-id="element-90">
                <span className="w-1.5 h-1.5 bg-red-600 rounded-full mr-3" data-id="element-91"></span>
                Pierdes {item}
              </motion.div>)}
          </div>
        </div>

        <div className="bg-neutral-900/50 p-6 rounded-lg border border-neutral-800" data-id="element-92">
          <p className="text-neutral-400 mb-4" data-id="element-93">Y encima te cae la culpa:</p>
          <div className="space-y-3 italic text-neutral-300 border-l-2 border-neutral-700 pl-4" data-id="element-94">
            <p data-id="element-95">“Debería estar agradecido.”</p>
            <p data-id="element-96">“Otros la tienen peor.”</p>
            <p data-id="element-97">“Soy débil por sentirme así.”</p>
          </div>
        </div>

        <div className="text-xl md:text-2xl font-medium text-white leading-relaxed" data-id="element-98">
          <p className="mb-2" data-id="element-99">Pero tu cuerpo no entiende discursos.</p>
          <p className="text-red-500 font-bold" data-id="element-100">
            Tu cuerpo solo entiende presión.
          </p>
          <p className="mt-4 text-neutral-400 text-base" data-id="element-101">
            Y si la presión no tiene salida…{' '}
            <span className="text-white border-b border-red-600" data-id="element-102">revienta</span>
            .
          </p>
        </div>
      </motion.div>
    </Section>;
}